// frontend/src/services/api.js
import axios from 'axios';

/**
 * Base URL:
 * - In dev we proxy /api → http://localhost:8000 via Vite.
 * - In prod we’ll also serve backend under /api behind the reverse proxy.
 * Using absolute paths (starting with /api) keeps both environments identical.
 */
const API_BASE = ''; // keep empty; we’ll always call with absolute '/api/...'

// Small helper to read/write the token consistently
const tokenStorage = {
  get() {
    return localStorage.getItem('access_token') || sessionStorage.getItem('access_token') || null;
  },
  set(token, remember = true) {
    (remember ? localStorage : sessionStorage).setItem('access_token', token);
  },
  clear() {
    localStorage.removeItem('access_token');
    sessionStorage.removeItem('access_token');
  }
};

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: false, // we use Authorization: Bearer, not cookies
});

// Attach token to every request if present
api.interceptors.request.use((config) => {
  const token = tokenStorage.get();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global 401 handler: drop token and send the user back to login
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      tokenStorage.clear();
      // optional: keep current location to return after login
      const here = window.location.pathname + window.location.search;
      const redirect = here && here !== '/login' ? `?next=${encodeURIComponent(here)}` : '';
      window.location.href = `/login${redirect}`;
    }
    return Promise.reject(err);
  }
);

export { tokenStorage };
export default api;
